module.exports = __webpack_public_path__ + "static/media/main-logo-no-text.fd07c123.svg";